import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42i3JSwpAERQAUN26n6TX8ykhU8rIwP7XhjI4o6NW+Wdz3xCR+mRmzkQUENGqpHWLxvQT5cZLDwBy8AaNlAOLYW2F0gAAAABJRU5ErkJggg=="};
